import { Icon } from '@/components/ds'

export interface AvisoAccesoProps {
  titulo: string
  /** Segunda línea: qué hacer al respecto. Un aviso sin salida no sirve. */
  detalle?: string
}

/**
 * Aviso de error dentro de la tarjeta de acceso.
 *
 * Reemplaza al toast para los errores de credenciales. El toast se va solo a
 * los pocos segundos: alguien que tipeó mal la contraseña y se quedó mirando
 * el teclado vuelve a la pantalla sin saber qué pasó, y el formulario se ve
 * exactamente igual que antes de intentar. El aviso inline se queda hasta que
 * la persona corrige algo.
 *
 * El toast sigue siendo el canal correcto para lo que NO es del formulario
 * —una sesión revocada desde otro dispositivo, por ejemplo—, porque eso no
 * tiene un campo que corregir.
 */
export function AvisoAcceso({ titulo, detalle }: AvisoAccesoProps) {
  return (
    <div
      role="alert"
      className="bg-destructive-bg border-destructive/25 flex items-start gap-[9px] rounded-[9px] border px-3 py-[11px]"
    >
      <Icon name="error" size={18} className="text-destructive mt-px" />
      <div className="flex min-w-0 flex-col gap-[3px]">
        <span className="text-destructive text-[12.5px] font-semibold">{titulo}</span>
        {detalle && (
          <span className="text-muted-foreground text-[11.5px] leading-[1.45]">{detalle}</span>
        )}
      </div>
    </div>
  )
}
